import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDocumentTitle } from "../utils/documentTitle";

const PageTitle = () => {
  const location = useLocation();
  const matterDetailsTree = useSelector(
    (state) => state.matterDetails?.matterDetailsTree
  );

  useEffect(() => {
    document.title = getDocumentTitle({
      pathname: location.pathname,
      locationState: location.state,
      matter: matterDetailsTree,
    });
  }, [location.pathname, location.state, matterDetailsTree]);

  return null;
};

export default PageTitle;
